import { Box, Container, Grid, Typography } from '@mui/material';
import { IMergedProfileScoreCategory } from '../../../../interfaces/gamification.interface';
import { colors } from '../../../../theme/theme';
import React from 'react';
import DefaultProfileScoreCategoryIcon from '../../../../components/Icons/DefaultProfileScoreCategoryIcon';
import { useNavigate } from 'react-router-dom';
import CustomButton from '../../../../components/MUIComponents/CustomButton';
import { ButtonTypeEnum } from '../../../../enums/button-type-enum';

interface IProfileScoreCard {
  category: IMergedProfileScoreCategory;
}

const ProfileScoreCategoryCard = (props: IProfileScoreCard) => {
  const { category } = props;
  const navigate = useNavigate();

  const moveToProfileCategory = (link: string): void => {
    navigate(link);
  };

  return (
    <Container
      disableGutters
      sx={{
        p: '22px 16px',
        backgroundColor: colors.dark05,
        minWidth: { xs: 300, lg: 'unset' },
      }}
    >
      <Box component="header" mb="12px">
        <Grid container height="50px" justifyContent="space-between">
          <Grid item width={50} height={50}>
            <Box
              sx={{
                width: '100%',
                height: '100%',
                fontSize: '30px',
                color: colors.stepperCompletedBg,
                borderRadius: '50%',
                backgroundColor: colors.dark10,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                overflow: 'hidden',
              }}
            >
              {category.icon ? (
                category.icon
              ) : (
                <DefaultProfileScoreCategoryIcon
                  letter={category.title.charAt(0)}
                />
              )}
            </Box>
          </Grid>
          <Grid item>
            <Box
              sx={{
                border: `1px solid ${colors.stepperCompletedBg}`,
                borderRadius: '50px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: 79,
                height: 24,
              }}
            >
              <Typography
                variant={'caption'}
                fontWeight={500}
                fontSize="10px"
                color={colors.stepperCompletedBg}
              >
                {category.points} {category.points > 1 ? 'pts' : 'point'}{' '}
                {category.disposable ? '' : 'each'}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box component="article">
        <Typography component="header" variant="h6" color="#142237" mb="16px">
          {category.title}
        </Typography>
        <Typography variant="caption" color={colors.dark60} mb="16px">
          {category.description}
        </Typography>
      </Box>
      <Box component="footer" mt="28px">
        {category.link && category.buttonText && (
          <CustomButton
            onClick={() => moveToProfileCategory(category.link ?? '')}
            variantType={ButtonTypeEnum.SECONDARY}
            sx={{
              borderRadius: 0,
              color: colors.bgDark,
              borderColor: colors.buttonBorder,
              fontSize: 10,
              padding: '12px 16px',
            }}
          >
            {category.buttonText}
          </CustomButton>
        )}
      </Box>
    </Container>
  );
};

export default ProfileScoreCategoryCard;
